<div *ngIf="visible" class="position-fixed top-0 start-50 translate-middle-x bg-dark text-white px-4 py-2 rounded mt-3 shadow width-90"
     style="z-index: 9999; transition: opacity 0.5s ease-in-out;">
  <img src="assets/images/icons/check-circle-green.svg" width="16" class="me-2" />
  {{ message }}
</div>